import * as React from 'react';
import styled from 'styled-components';

export const DropListItemText: React.FC = ({ children }) => {
    return (
        <MenuRow role="none">
            <Button disabled tabIndex={-2} role="menuitem">
                <Caption>{children}</Caption>
            </Button>
        </MenuRow>
    );
};

// this is from starryUI8
const MenuRow = styled.li`
    list-style: none;
    padding: 0;
    margin: 0;
`;

const Caption = styled.span`
    display: grid;
    padding: 8px 8px;
    max-width: 230px;
`;

const Button = styled.button`
    padding: 0;
    margin: 0 8px;
    width: calc(100% - 20px);
    text-align: left;
    background: transparent;
    border: 0;
    pointer-events: none;
`;
